<app-form-input
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[value]="radioButtonValue"
	
	[label]="labelRadio"
	[type]="'radio'"
	[rule]="'pattern_29|required'"
	[errorMessage]="{'required' : 'ctr_1203'}"
	[radios]="[
		{
			label: step7.getoui,
			value: oui
		},
		{
			label: step7.getnon,
			value: non
		}
	]"
	[name]="radioButtonCtrlName"
>
</app-form-input>
